"use client";

import React from "react";
import Image from "next/image";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";
import imgMainImage from "@/assets/images/landing/d94b23136dedb7aac478a6af278c0b61abb28501.png";

export default function MobileVideoCarousel() {
	return (
		<div className="mb-8">
			<div className="bg-[#1a2c20] rounded-2xl p-5">
				{/* Video Card */}
				<div className="relative h-[233px] rounded-2xl overflow-hidden mb-3 bg-black/50 backdrop-blur-sm">
					<Image
						src={imgMainImage}
						alt="Video Thumbnail"
						fill
						className="object-cover opacity-70"
					/>
					<div className="absolute inset-0 flex items-center justify-center">
						<div className="w-16 h-16 rounded-full bg-[#66B327] flex items-center justify-center">
							<svg
								className="w-8 h-6 ml-1"
								fill="none"
								viewBox="0 0 65 45"
							>
								<path d={svgPaths.p2adfbf00} fill="#66B327" />
								<path d={svgPaths.p10a50300} fill="white" />
							</svg>
						</div>
					</div>
				</div>

				<h3 className="text-white text-xl font-bold mb-2 leading-7">
					Professional-Grade Property Intelligence
				</h3>
				<p className="text-white text-xs mb-2">
					Outperform with Tax Lien Vest: Smarter, Faster Tax Lien
					Investing
				</p>
				<p className="text-[rgba(255,255,255,0.7)] text-xs leading-relaxed">
					Professional investors need accurate, comprehensive data to
					make confident investment decisions. Tax Lien Vest
					eliminates research guesswork by providing
					institutional-grade property intelligence that transforms
					complex tax lien analysis into streamlined investment
					workflows.
				</p>
			</div>

			{/* Carousel Controls */}
			<div className="flex items-center gap-2 mt-5">
				<button
					className="w-14 h-14 rounded-full backdrop-blur-md flex items-center justify-center shrink-0"
					style={{
						background:
							"linear-gradient(90deg, rgba(101, 222, 158, 0.12), rgba(0, 0, 0, 0.05))",
					}}
				>
					<svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
						<path
							d="M15 18L9 12L15 6"
							stroke="#A7FF5E"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2.4"
						/>
					</svg>
				</button>

				<div className="flex-1 bg-[#22402e] backdrop-blur-md rounded-2xl border border-[rgba(255,255,255,0.12)] px-4 py-3 flex items-center justify-center gap-1.5">
					<div className="w-[15px] h-1.5 rounded-full bg-[#a7ff5e]"></div>
					{[...Array(5).keys()].map((i) => (
						<div
							key={i}
							className="w-1.5 h-1.5 rounded-full bg-[rgba(255,255,255,0.1)]"
						></div>
					))}
				</div>

				<button
					className="w-14 h-14 rounded-full backdrop-blur-md flex items-center justify-center shrink-0 rotate-180"
					style={{
						background:
							"linear-gradient(90deg, rgba(101, 222, 158, 0.12), rgba(0, 0, 0, 0.05))",
					}}
				>
					<svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
						<path
							d="M15 18L9 12L15 6"
							stroke="#A7FF5E"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2.4"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
}
